var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-start align-items-center"},[_c('div',{staticClass:"number-circle"},[_c('span',[_vm._v(_vm._s(_vm.number))])]),_c('span',{staticClass:"font-weight-bold text-primary",staticStyle:{"font-size":"32px"}},[_vm._v(" "+_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }